import useBindActionCreators from 'common/hooks/useBindActionCreators';

import { stationsOperations } from '../store';

export const useStationsOperations = (): typeof stationsOperations => {
  const bindedActions = useBindActionCreators(stationsOperations);
  return bindedActions;
};
